import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createLeave, fetchMyAttendance } from "../../../service/api";


export const getMyAttendance = createAsyncThunk(
    "myAttendance/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchMyAttendance(params)
            console.log("attendance", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)


// export const delteLeave = createAsyncThunk(
//     "leave/delete",
//     async (formValue, { rejectWithValue }) => {
//         try {
//             const response = await delteLeaveRequest(formValue)
//             if (response.status === 201) {
//                 console.log("delete", response)
//             }
//         } catch (error) {
//             return rejectWithValue(error.response || error)
//         }
//     }
// )


export const addLeave = createAsyncThunk(
    "leave/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createLeave(formValue)
            if (response.status === 201) {
                console.log("leve", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

export const editLeave = createAsyncThunk(
    "leave/edit",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateLeaveRequest(newData)
            if (response.status === 201) {
                console.log("edit leave", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)


const leaveSlice = createSlice({
    name: "myAttendance",
    initialState: {
        myAttendance: [],
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            //GET
            .addCase(getMyAttendance.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getMyAttendance.fulfilled, (state, action) => {
                state.isLoading = false;
                state.myAttendance = action.payload.data;

            })
            .addCase(getMyAttendance.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })


            // POST
            .addCase(addLeave.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(addLeave.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(addLeave.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })


            //PUT
            .addCase(editLeave.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(editLeave.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(editLeave.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })

    }
})
export default leaveSlice.reducer;